/* eslint-disable jsx-a11y/iframe-has-title */
export const Anatomy = () => {
  return <section className="Anatomy">
    <iframe src="https://www.ypo.education/csc-MjMzOTY0OA==/s-16/c-14/" 
      id="ypoedu-container" 
      name="ypoedu-container" 
      width="100%"
      height="100vh !important"
      border="0px" 
      style={{
        height: "100vh !important",
        width: "100%"
      }} 
    allowFullScreen="allowfullscreen"></iframe><script src="https://www.ypo.education/js/ypo-edu-embed.js"></script>
  </section>
}